/**
 * Collapses a burst of calls sharing a key into the last one.
 *
 * A bulk action fires one request per row and every one of them reports the same cache as stale, so
 * the refreshes behind them have to coalesce or a ten row delete costs ten reads.
 */
export const coalesceByKey = (delayMs: number) => {
	const pending = new Map<string, ReturnType<typeof setTimeout>>()

	return (key: string, run: () => void): void => {
		const scheduled = pending.get(key)
		if (scheduled) {
			clearTimeout(scheduled)
		}

		pending.set(
			key,
			setTimeout(() => {
				pending.delete(key)
				run()
			}, delayMs),
		)
	}
}
